import { Children, isValidElement } from 'react'
import { Platform, View, type ViewProps } from 'react-native'
import { BottomSheetsBackButton } from '../bottom-sheets-back-button'
import { BottomSheetsDescription } from '../bottom-sheets-description'
import { BottomSheetsRightButton } from '../bottom-sheets-right-button'
import { BottomSheetsTitle } from '../bottom-sheets-title'

import * as Comp from './bottom-sheets-header.styles'

const IS_IOS = Platform.OS === 'ios'

export function BottomSheetsHeader({ children, testID }: ViewProps) {
  const renderBackButton = Children.map(children, child => {
    if (!isValidElement(child)) return
    if (child.type === BottomSheetsBackButton) return child
  })

  const renderContent = Children.map(children, child => {
    if (!isValidElement(child)) return
    if (
      child.type === BottomSheetsTitle ||
      child.type === BottomSheetsDescription
    )
      return child
  })

  const renderRightButton = Children.map(children, child => {
    if (!isValidElement(child)) return
    if (child.type === BottomSheetsRightButton) return child
  })

  const checkIfDoesNotHaveBackButtonInChildren =
    Children.toArray(renderBackButton).length === 0

  return (
    <Comp.Container testID={testID}>
      {IS_IOS ? (
        <>
          {checkIfDoesNotHaveBackButtonInChildren ? (
            <View
              style={{
                width: 40,
                height: 40,
              }}
            />
          ) : (
            renderBackButton
          )}
          <View style={{ gap: 4, flex: 1 }}>{renderContent}</View>
        </>
      ) : (
        <View
          style={{
            paddingRight: 8,
            flexDirection: 'row',
            alignItems: 'center',
            maxWidth: '80%',
            flex: 1,
          }}
        >
          {renderBackButton}
          <View style={{ gap: 4 }}>{renderContent}</View>
        </View>
      )}
      <View>{renderRightButton}</View>
    </Comp.Container>
  )
}
